<div class="container-fluid py-5" style="background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); min-height: 100vh;">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6">
      
      <!-- Loading State -->
      <div *ngIf="isLoading" class="card shadow-lg border-0 rounded-4 overflow-hidden animate__animated animate__fadeIn">
        <div class="card-body p-5 text-center">
          <div class="spinner-border text-primary mb-4" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <h4 class="text-secondary fw-bold">Validando información</h4>
          <p class="text-muted">Por favor espera un momento...</p>
        </div>
      </div>

      <!-- Main Form Card -->
      <div *ngIf="!isLoading && !isValidated && !isSuccess" class="card shadow-lg border-0 rounded-4 overflow-hidden animate__animated animate__fadeInUp">
        <div class="card-header bg-primary py-4 text-center">
          <h3 class="text-white mb-0 fw-bold">Cargar Documento</h3>
          <p class="text-white-50 mb-0">Sube tu documento de identificación para continuar</p>
        </div>
        <div class="card-body p-4 p-md-5">
          <form [formGroup]="createCreditForm" (ngSubmit)="saveDocuments()">
            
            <div class="mb-4">
              <label for="documentFile" class="form-label fw-semibold text-secondary">Documento de identificación</label>
              <div class="upload-zone border-2 border-dashed rounded-3 p-4 text-center" 
                   [class.border-primary]="createCreditForm.get('documents').value"
                   style="border-color: #dee2e6; transition: all 0.3s ease;">
                <i class="mdi mdi-cloud-upload d-block mb-3 text-primary" style="font-size: 3rem;"></i>
                <input type="file" 
                       id="documentFile" 
                       class="form-control d-none" 
                       accept=".jpg, .jpeg, .png, .pdf" 
                       (change)="onFileSelected($event)" 
                       #fileInput>
                
                <button type="button" class="btn btn-outline-primary px-4" (click)="fileInput.click()">
                  {{ createCreditForm.get('documents').value ? 'Cambiar archivo' : 'Seleccionar archivo' }}
                </button>
                
                <div *ngIf="createCreditForm.get('documents').value" class="mt-3 text-success">
                  <i class="mdi mdi-check-circle me-1"></i>
                  {{ createCreditForm.get('documents').value[0]?.name }} seleccionado
                </div>
                <p class="mt-2 text-muted small">Formatos permitidos: JPG, PNG, PDF</p>
              </div>
            </div>

            <div class="form-check mb-4 custom-checkbox">
              <input class="form-check-input" type="checkbox" formControlName="authorize" id="authorizeCheckbox">
              <label class="form-check-label text-secondary small" for="authorizeCheckbox">
                Autorizo el tratamiento de mis datos personales de acuerdo con la política de privacidad de Bakna.
              </label>
              <div class="invalid-feedback d-block" *ngIf="createCreditForm.get('authorize').touched && createCreditForm.get('authorize').invalid">
                Debes autorizar el tratamiento de datos para continuar.
              </div>
            </div>

            <div class="text-center">
              <button type="submit" 
                      class="btn btn-primary btn-lg w-100 py-3 shadow-sm rounded-pill fw-bold" 
                      [disabled]="createCreditForm.invalid">
                Guardar y Continuar
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Success State -->
      <div *ngIf="!isLoading && isSuccess" class="card shadow-lg border-0 rounded-4 overflow-hidden animate__animated animate__zoomIn">
        <div class="card-body p-5 text-center">
          <div class="success-icon bg-success bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4" style="width: 80px; height: 80px;">
            <i class="mdi mdi-check text-success" style="font-size: 3rem;"></i>
          </div>
          <h2 class="fw-bold text-dark">¡Recibido con éxito!</h2>
          <p class="text-muted fs-5 mb-4">Tu documento ha sido cargado correctamente. Estamos procesando tu solicitud.</p>
          <button class="btn btn-primary px-5 py-2 rounded-pill fw-bold" (click)="isValidated = true; isSuccess = false">
            Regresar al inicio
          </button>
        </div>
      </div>

      <!-- Already Validated State -->
      <div *ngIf="!isLoading && isValidated && !isSuccess" class="card shadow-lg border-0 rounded-4 overflow-hidden animate__animated animate__fadeIn">
        <div class="card-body p-5 text-center">
          <div class="info-icon bg-info bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4" style="width: 80px; height: 80px;">
            <i class="mdi mdi-information-variant text-info" style="font-size: 3rem;"></i>
          </div>
          <h3 class="fw-bold text-dark">Documentación Completa</h3>
          <p class="text-muted mb-4">Esta solicitud ya cuenta con los documentos necesarios vinculados.</p>
          <a routerLink="/dashboard" class="btn btn-outline-primary px-5 py-2 rounded-pill fw-bold">
            Ir al Dashboard
          </a>
        </div>
      </div>

    </div>
  </div>
</div>